import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/fashionable-inc-shopify-plus-partnership-case-study.es.md?raw";

const PATH = "/es/recursos/caso-fashionable-inc-colaboracion";
const ALT = "/resources/fashionable-inc-partnership-case-study";
const TITLE = "Fashionable INC: más de 6 años de partnership Shopify Plus en tres tiendas";
const META_TITLE = "Caso Fashionable INC: Shopify Plus · Shugert";
const DESCRIPTION = "Cómo Shugert apoya a Fashionable INC en tres tiendas Shopify Plus durante 6+ años de migraciones, SEO, custom development y performance.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Perfil de Shugert Marketing", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Fashionable Canes", publisher: "Fashionable INC", href: "https://fashionablecanes.com/" },
  { label: "Fashionable Hats", publisher: "Fashionable INC", href: "https://fashionablehats.com/" },
  { label: "TENS Units", publisher: "Fashionable INC", href: "https://tensunits.com/" },
];

const RELATED = [
  { label: "Caso Fashionable Canes", href: "/es/recursos/caso-fashionable-canes-seo" },
  { label: "Agencia Shopify Plus", href: "/es/agencia-shopify-plus" },
  { label: "Engineering Shopify continuo", href: "/es/retainer" },
  { label: "Todos los casos Shopify", href: "/es/proyectos" },
];

export const Route = createFileRoute("/es/recursos/caso-fashionable-inc-colaboracion")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Caso de partnership Shopify Plus", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Caso de partnership Shopify Plus" }),
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Proyectos", path: "/es/proyectos" }, { name: "Caso Fashionable INC", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="es" path={PATH} title={TITLE}
        excerpt="Qué cambia cuando el trabajo Shopify se convierte en una relación operativa de más de seis años para tres tiendas Plus y no en una secuencia de proyectos desconectados."
        body={body} updated="Agosto de 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={10}
        focus="Cómo continuidad técnica, lifecycle de themes, SEO, custom development, performance y governance de portfolio funcionan a través de tres tiendas Shopify Plus durante años."
        audience="Organizaciones multi-store en Shopify Plus cuyo roadmap cruza repetidamente ingeniería, SEO, performance, migraciones y decisiones de plataforma."
        sources={SOURCES} related={RELATED}
        category="Caso de partnership Shopify Plus" backLabel="← Proyectos" backHref="/es/proyectos"
        cta={{ eyebrow: "Shopify Plus multi-store", title: "Conserva contexto cuando el roadmap dura más que un proyecto.", body: "Recomendamos capacidad continua únicamente cuando el roadmap cruza repetidamente sistemas, SEO, performance e ingeniería y conservar contexto tiene valor medible.", label: "Hablar del roadmap", href: "/es/cotizacion?intent=retainer&source=fashionable-inc-case-study" }}
      />
    </SiteShell>
  ),
});
